"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetsService = void 0;
class WidgetsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1Widgets({ authorization = 'Bearer <token>', }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/Widgets',
            headers: {
                Authorization: authorization,
            },
            errors: {
                400: `Request is incorrect.`,
                401: `Request is incorrect.`,
                403: `Request is incorrect.`,
                500: `Internal server error, try later.`,
            },
        });
    }
}
exports.WidgetsService = WidgetsService;
